import { observer } from 'mobx-react-lite';

import Module from './Module';

import OptionsBlock from '@/components/Hud/OptionsBlock/OptionsBlock';
import AppState, { POPUPS, SCREENS } from '@/js/AppState';
import Chapters from '@/js/Chapters';
import Texts from 'react-sdk/Texts';
import classes from './ScreenModules.module.css';
import UserWidget from '@/components/shared/UserWidget/UserWidget';
import Button from '@/components/shared/Button/Button';
import LeaderboardButton from '@/components/Hud/LeaderboardButton/LeaderboardButton';
import PopupsManager from 'react-sdk/PopupsManager';
import GameOverlay from '../ScreenGame/GameOverlay';
import Popups from '@/components/popups/Popups';
import Chapter from '@/js/Chapter';

const ScreenModules = () => {

  function onUserDisconnect() {
    AppState.setScreen(SCREENS.HOME)
  }

  return (

    <div className={classes.ScreenModules}>
      <div className={classes.ModulesContainer}>
        <div className={classes.userWidget}>
          {/* <UserWidget userEmail={AppState.vertxClient.UserData.getUserMail()} onDisconnect={onUserDisconnect} /> */}

        </div>
        <div className={classes.content}>
          <div className={classes.modules}>
            {Chapters.all.map((c, index) => {
              let prev = index > 0 ? Chapters.all[index - 1] : null
              return (
                <Module chapter={c}
                  locked={c.dateLocked}
                  prevChapter={prev}
                  inProgress={c.inProgress}
                  key={c.id}
                />
              )
            })}
          </div>
        </div>
        {AppState.debugMode &&
        <div className={classes.debug}>
          <details>
            <summary>DEBUG</summary>
            <div>
              {AppState.currentSave &&
              <button onClick={() => {
                AppState.deleteSave(false)
              }}>Supprimer sauvegarde (et reload)</button>}
              <button onClick={() => {
                AppState.vertxClient.GroupUserRemove(AppState.vertxClient.UserData.getUniverse(), AppState.group.groupId, AppState.vertxClient.UserData.getUserID(), (success, msg, data) => {
                        if(success)
                          AppState.deleteSave(true)
                        else
                          console.error("GroupUserRemove error : " + msg)

                      })
              }
              }>Quitter groupe (supprime également la sauvegarde et reload)</button>

              <button onClick={ () => AppState.setScreen(SCREENS.ECRAN_FINAL)}>Ecran de fin </button>
              <button onClick={ () => PopupsManager.open(POPUPS.CHAPTER_END, Chapters.all[0])}>page chapter 1 end</button>
              <button onClick={ () => PopupsManager.open(POPUPS.CHAPTER_END, Chapters.all[1])}>page chapter 2 end</button>
              <button onClick={ () => PopupsManager.open(POPUPS.CHAPTER_END, Chapters.all[2])}>page chapter 3 end</button>
            </div>



          </details>
        </div>}
      </div>

      {!AppState.leaderboardDisabled && AppState.hudVisibility && AppState.UI_visibilities.leaderboardBtn &&
      <LeaderboardButton />}

      {PopupsManager.someOpened && <GameOverlay key={"popup-overlay"}/>}

      <Popups />

      <OptionsBlock in_game={false}/>
    </div>
  );
};

export default  observer(ScreenModules)
